import { Card, Col, Input, Row, Select, Spin, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import StatusSelect from "../../../components/StatusSelect";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";

import DownloadTableButtons from "../../../components/DownloadTableButtons";
import getGlListAction, { rightAction } from "../../../redux/actions";
import definedApi from "../../../services/definedApi";

//global distructures
const { Text, Link, Title } = Typography;
const Search = Input;
const { manageGeneralLedgerItems } = appStatic;

const columns = [
  {
    title: "Account",
    dataIndex: "account",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "GL Code",
    dataIndex: "glCode",
    sorter: (a, b) => a.glCode.localeCompare(b.glCode),
  },
  {
    title: "Account Type",
    dataIndex: "accountType",
  },
  {
    title: "Disabled?",
    dataIndex: "disabled",
    key: "disabled",
    render: (text) => (
      <Text strong style={{ color: text ? "green" : "red" }}>
        {text ? "Yes" : "No"}
      </Text>
    ),
  },
  {
    title: "Manual Entries Allowed?",
    dataIndex: "manualEntriesAllowed",
    key: "manualEntriesAllowed",
    render: (text) => (
      <Text strong style={{ color: text ? "green" : "red" }}>
        {text ? "Yes" : "No"}
      </Text>
    ),
  },
  {
    title: "Used As",
    dataIndex: "usedAs",
    // sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
];

const GLA0100 = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const {
    userData,
    // onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
  } = props;
  const { session } = userData;
  const [glList, setGlList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rightViewBtn, setRightViewBtn] = useState("default");
  const dispatch = useDispatch();

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GlAccount, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              account: element?.name ? element?.name : "No description",
              glCode: element?.glCode ? element?.glCode : "No Code",
              accountType: element?.type?.value,
              disabled: element?.disabled ? "Yes" : "No",
              manualEntriesAllowed: element?.manualEntriesAllowed
                ? "Yes"
                : "No",
              usedAs: element?.usage?.value,
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  function handleStatusChange(value) {
    let tempList = originalList;

    switch (value.toLowerCase()) {
      case "active":
        tempList = originalList.filter((item) => item.disabled === false);
        break;
      case "disabled":
        tempList = originalList.filter((item) => item.disabled === true);
        break;
      default:
        return tempList;
    }

    setGlList(tempList);
  }
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setGlList(originalList);
      return;
    }

    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.account?.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.glCode?.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.accountType?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setGlList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  const onSelectItem = (selectedRowKeys, objParam) => {
    console.log("on select: ", props);

    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    dispatch({
      type: cnt.RIGHT_DETAIL_BTN,
    });
  };
  //END METHODS DECLARED

  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    BOM.HasPermission("CREATE_GLACCOUNT") && rightAction(cnt.RIGHT_ADD_BTN);

    getGlListAction({ session }, setGlList, setOriginalList, setLoading);
  }, []);

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-gla0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0100", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_GLACCOUNT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_GLACCOUNT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={appLabel.generalLedger}
        pageItems={manageGeneralLedgerItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"General Ledger List"}
        extra={
          <Col>
            <StatusSelect handleStatusChange={handleStatusChange} />
          </Col>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={loading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by GL Code or Account Name or Account Type..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={glList}
              columns={columns}
              fileName={"General Ledger List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={glList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction, getGlListAction };

export default connect(mapStateToProps, mapDispatchToProps)(GLA0100);
